import { RunSchema } from '@/types/schema';

const DEFAULT_RUN_NAMES = ['RunnableSequence', 'RunnableParallel'];

export function getRunName(run: RunSchema) {
  const mapName = run.tags?.find((i) => i.startsWith('map:'));

  if (
    DEFAULT_RUN_NAMES.includes(run.name) &&
    run.run_type === 'chain' &&
    mapName != null
  ) {
    return mapName;
  }

  return run.name;
}
